var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-easy-lightbox',{attrs:{"visible":_vm.visible,"imgs":_vm.images,"index":_vm.index},on:{"hide":function($event){return _vm.$emit('update:visible', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }